// extracted by mini-css-extract-plugin
module.exports = {"families":"Families_families__j141K"};